import React, { PureComponent } from "react";
import { Loader } from "react-loaders";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import { pickValue } from "./utils";
import { fetchCompetitionMetrics } from "../../api/MetricsService";
import Teams from "../../api/Teams";
import Auth from "routes/Auth";

// Lead Time gets its own dedicated MetricsReport fetch with
// include=lead_scores so weighted_lead_time (and any future
// per-product lead_score breakdowns) are guaranteed to be present
// without piggybacking on the shared Analysis fetch.
class LeadTime extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reports: null,
      loading: true,
    };
  }

  componentDidMount() {
    this._mounted = true;
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.roundId !== this.props.roundId) {
      this.fetch();
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetch = () => {
    const { roundId } = this.props;
    if (!roundId) return;
    const currentTeam = Teams.currentTeam();
    const competitionId = currentTeam ? Number(currentTeam.competition) : null;
    fetchCompetitionMetrics(competitionId || null, roundId, { include: 'lead_scores' })
      .then(data => {
        if (this._mounted) this.setState({ reports: data, loading: false });
      })
      .catch(() => {
        if (this._mounted) this.setState({ loading: false });
      });
  };

  render() {
    const { teamId, teams, competitionMetrics } = this.props;
    const { reports, loading } = this.state;

    if (loading && !reports) {
      return <Loader type="ball-scale-ripple" active />;
    }

    const teamsIds = teams.map(i => Number(i.id));
    const data = Auth.getPosition() === 'Student'
      ? reports
        ? reports.filter(i => teamsIds.includes(Number(i.team)))
        : []
      : competitionMetrics
        ? competitionMetrics.map(i => ({
            ...i,
            weighted_lead_time: i['Weighted Lead Time'] || 0,
          }))
        : [];
    const obj = data.find(i => Number(i.team) === teamId);
    // Guard against null/undefined — Year 1 rows can arrive with the
    // field unset, and .toFixed on null throws mid-render.
    const weightedLeadTime = (Number(obj && obj.weighted_lead_time) || 0).toFixed(2);
    const chartData = pickValue(teams, data, 'weighted_lead_time').map(i => ({
      ...i,
      value: Number((i.value || 0).toFixed(2)),
    }));

    return (
      <OnePanelChart
        title="Lead Time"
        chartTitle="WEIGHTED LEAD TIME"
        vertical
        suffix=" hrs"
        data={chartData}
        teams={teams}
      >
        <Text>
          Your team's weighted lead time is <b>{weightedLeadTime}</b> hours.
          Lead time is how long it takes your product to travel from your
          inventory to a customer after they place an order. The number is
          weighted by customer demand, so greater demand pulls more weight in
          the average. A shorter lead time means faster delivery, which
          makes customers more likely to pick you over a slower competitor.
        </Text>
      </OnePanelChart>
    );
  }
}

export default LeadTime;



// WEBPACK FOOTER //
// ./src/components/analysis/LeadTime.js